import request from '@/api/request.js'

// 查询表单组
export function getCrossGroupModelsByUser(type, isSub = false) {
  return request({
    url: `wflow/cross/${isSub ? 'sub/' : ''}list/byUser`,
    method: 'get',
    params: {
      type: type
    }
  })
}

// 获取控制台统计数据
export function getCrossProcessCountData() {
  return request({
    url: `wflow/cross/instance/count`,
    method: 'get'
  })
}

//获取用户发起的实例
export function getUserCrossSubmittedList(params) {
  return request({
    url: `wflow/cross/mySubmitted`,
    method: 'get',
    params: params
  })
}
export function getUserSubmittedList(params) {
  return request({
    url: `wflow/cross/mySubmitted`,
    method: 'get',
    params: params
  })
}
export function getUserSubmittedListFilter(params) {
  return request({
    url: `wflow/cross/mySubmitted`,
    method: 'get',
    params: params
  })
}

//获取用户待办的实例
export function getUserCrossTodoList(params) {
  return request({
    url: `wflow/cross/todoList`,
    method: 'get',
    params: params
  })
}

//获取我已处理的所有审批实例
export function getIdoCrossList(params) {
  return request({
    url: `wflow/cross/idoList`,
    method: 'get',
    params: params
  })
}

// 获取抄送我的流程
export function getCcMeCrossList(params) {
  return request({
    url: `wflow/cross/ccMe`,
    method: 'get',
    params: params
  })
}

// 获取作废流程
export function getCanceledCrossList(params){
  return request({
    url: `wflow/cross/canceledList`,
    method: 'get',
    params: params
  })
}

//获取所有发起的实例
export function getSubmittedCrossList(params){
  return request({
    url: `wflow/cross/submittedList`,
    method: 'get',
    params: params
  })
}
